import { authService } from './auth.service';

const SESSION_EXPIRED_EVENT = 'niup:session-expired';
const REDIRECT_DELAY_MS = 3000;

class SessionExpiryService {
  private _expiring = false;

  handleSessionExpired(): void {
    if (this._expiring) return;
    this._expiring = true;

    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));

    setTimeout(() => {
      authService.logout();
    }, REDIRECT_DELAY_MS);
  }

  isExpiring(): boolean {
    return this._expiring;
  }
}

export const sessionExpiry = new SessionExpiryService();
